import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/about.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Litigation = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
    AOS.refresh();
  }, []);

  return (
    <div>
      {/* HERO SECTION */}
      <section className="about-hero" data-aos="fade-up">
        {/* BLURRED IMAGE LAYER */}
        <div className="hero-bg"></div>

        {/* CONTENT (NOT BLURRED) */}
        <div className="hero-content text-center text-white">
          <div className="container">
            <h1 className="fw-bold text-white">
              Redevelopment & Self-Redevelopment
            </h1>
            <p className="mt-3">
              Redevelopment & Self-Redevelopment Consultancy (Present Work)
            </p>
          </div>
        </div>
      </section>
      <section
        className="about-content"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div className="container mt-4 mb-3">
          <p>
            The Firm is presently engaged in multiple high-value redevelopment
            and self-redevelopment projects across Maharashtra, offering
            comprehensive legal consultation, structuring, and regulatory
            guidance:
            <br />
            1. Cluster Redevelopment at Versova, Andheri (Mumbai): Providing
            legal consultation to M/s Bombay Brigade for redevelopment of 89
            residential buildings, involving complex FSI/TDR structuring,
            society negotiations, and compliance under DCPR 2034.
            <br />
            2. Powai Landlord Development (Mumbai): Advising the Sharma
            Families, landlords of large Powai land parcels, in hectare-scale
            redevelopment, including landlord-developer structuring, title due
            diligence, and leasehold-to-freehold transition issues.
            <br />
            3. Standalone Redevelopment Projects (Mumbai & Navi Mumbai):
            Providing legal consultation to multiple cooperative societies and
            developers for redevelopment of standalone projects such as:
            <br />
            (i) Ganesh Mahal at Ghatkopar. <br />
            (ii) Rameshwardham at Vile Parle. <br />
            (iii) Saidarshan CHS at Andheri. <br />
            (iv) Rashtra Sarathi at Mulund. <br />
            (v) Eighty Roses at Vikhroli. <br />
            (vi) Revere CHS at Vashi. <br />
            (vii) Pulin CHS at Seawoods and several other ongoing residential
            redevelopment schemes.
            <br />
            4. Self-Redevelopment Advisory (Mumbai, Navi Mumbai, Pune): Guiding
            cooperative housing societies in undertaking self-redevelopment
            under the Maharashtra Government GR dated 13th September 2019 and
            the Housing Policy 2025. Present mandates include:
            <br />
            (i) Tilak Safalya CHS at Chembur <br />
            (ii) Shubham CHS at Panvel <br />
            (iii) Multiple societies in Pune city and metropolitan region.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Litigation;
